import { assoc, compose, pick } from 'ramda'

export const cleanRequest = (item, name) => {
  return compose(pick(['id', 'name', 'value']), assoc('value', JSON.stringify(item.value)), assoc('name', name))(item)
}
